export default (password) => {
  // Minimum of 1 Uppercase Letter
  if (/[A-Z]/.test(password) === false) { return false; }

  // Minimum of 1 lowercase Letter
  if (/[a-z]/.test(password) === false) { return false; }

  // Minimum of 1 Number
  if (/\d/.test(password) === false) { return false; }

  // Minimum of 1 special char
  return /[ !"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/.test(password) !== false;
};
